import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestUpdates from "./components/LatestUpdates";
import Ranking from "./components/Ranking";
import Categories from "./components/Categories";
import HowItWorks from "./components/HowItWorks";
import Featured from "./components/Featured";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Footer from "./components/Footer";

function SeoJsonLd() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: "妖精漫画",
          description: "妖精漫画连载/妖精漫画追更入口，最新话进度随时盯",
          inLanguage: "zh-CN",
        },
        {
          "@type": "WebPage",
          name: "妖精漫画 - 追更入口",
          description: "妖精漫画追更入口，专注连载进度与最新话更新提醒",
          inLanguage: "zh-CN",
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "怎么收藏自己想追的漫画？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "在作品卡片或详情页点击收藏追更按钮即可。收藏后，每次打开网站都能在你的追更列表里看到最新话进度。",
              },
            },
            {
              "@type": "Question",
              name: "漫画的连载进度会实时更新吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "会的。每当作品更新最新话，我们会同步刷新连载状态与章节进度，并在最新更新板块按更新时间排序。",
              },
            },
          ],
        },
      ],
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
}

export default function Home() {
  return (
    <>
      <SeoJsonLd />
      <Navbar />
      <main>
        <Hero />
        <LatestUpdates />
        <Ranking />
        <Categories />
        <HowItWorks />
        <Featured />
        <FAQ />
        <About />
      </main>
      <Footer />
    </>
  );
}